// @flow
import styled from "styled-components";
import { spacers, spacer } from "../react-theme/utils/spacers";

import type { StyledComponent } from "styled-components";
import type { Theme } from "../react-theme/types";
import type { Node } from "react";

export type Props = {
  +className?: string,
  +componentStack: string,
  +error: Error,
};

// $FlowFixMe
const StyledBoundary: StyledComponent<{}, Theme, *> = styled.div`
  padding: ${spacers(2, 1)};
  margin-bottom: ${spacer(2)};
  background-color: #e9ecef;
  border-radius: 0.3em;
`;

// $FlowFixMe
const StyledStack = styled.pre`
  display: block;
  font-size: 87.5%;
  color: #212529;
  font-style: italic;
`;

/**
 */
const ErrorBoundaryFallback = ({
  className,
  componentStack,
  error,
}: Props): Node => (
  <StyledBoundary className={className}>
    <h2>{error.toString()}</h2>
    <StyledStack className="debug">{componentStack}</StyledStack>
  </StyledBoundary>
);

ErrorBoundaryFallback.displayName = "BI.ErrorBoundaryFallback";

export default ErrorBoundaryFallback;
